(function() {
  if (window.__compatibilityFlowAssetLoaded) return;
  window.__compatibilityFlowAssetLoaded = true;

  function getCopyIconMarkup(root) {
    const scopedTemplate = root && root.querySelector
      ? root.querySelector('[data-compatibility-copy-icon]')
      : null;
    const template = scopedTemplate || document.querySelector('[data-compatibility-copy-icon]');
    return template ? template.innerHTML.trim() : '';
  }

  function getCompatibilityModalContent(triggerElement) {
    const explicitTarget = triggerElement && triggerElement.getAttribute && triggerElement.getAttribute('data-compatibility-target');

    if (explicitTarget) {
      const targetedContent = document.querySelector(explicitTarget);
      if (targetedContent) return targetedContent;
    }

    const sectionRoot = triggerElement && triggerElement.closest
      ? triggerElement.closest('[data-compatibility-section]')
      : null;

    if (sectionRoot) {
      const localContent = sectionRoot.querySelector('[data-compatibility-modal-source]');
      if (localContent) return localContent;
    }

    return document.querySelector('[data-compatibility-modal-source]');
  }

  function openCompatibilityModal(contentElement) {
    if (!contentElement || !window.MinimogTheme || !MinimogTheme.Modal) {
      console.error('Modal content or MinimogTheme.Modal not available');
      return;
    }

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
    document.documentElement.classList.add('force-scrollbar');

    const modal = new MinimogTheme.Modal();
    const contentClone = document.createElement('div');
    contentClone.innerHTML = contentElement.innerHTML;
    contentClone.classList.add('compatibility-modal-content');

    initializeCompatibilityFlow(contentClone, modal);

    function getCompatibilityModalRoot() {
      return modal && modal.modal ? modal.modal : null;
    }

    function applyCompatibilityModalChrome() {
      const modalRoot = getCompatibilityModalRoot();
      if (!modalRoot) return;

      modalRoot.classList.add('compatibility-flow-modal');

      const closeButton = modalRoot.querySelector('.m-modal--close');
      const closeSlot = modalRoot.querySelector('[data-flow-close-slot]');
      const modalContent = modalRoot.querySelector('.m-modal--content');

      if (modalContent) {
        modalContent.style.overflowY = 'scroll';
      }

      if (!closeButton || !closeSlot || closeSlot.contains(closeButton)) return;

      closeButton.classList.add('compatibility-flow-close-in-row');
      closeSlot.appendChild(closeButton);
    }

    modal.addEventListener('modal:opened', function() {
      const scrollY = window.scrollY;
      document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
      document.body.style.top = '-' + scrollY + 'px';
      document.body.classList.add('m-modal-open');
      applyCompatibilityModalChrome();
    });

    modal.addEventListener('modal:closed', function() {
      const scrollY = document.body.style.top;
      document.body.classList.remove('m-modal-open');
      document.body.style.top = '';

      requestAnimationFrame(function() {
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
      });
    });

    modal.appendChild(contentClone);
    modal.setWidth('90%');
    modal.setSizes('m-form-ask-question m-gradient');
    modal.open();
    applyCompatibilityModalChrome();
  }

  function initializeCompatibilityFlow(root, modal) {
    const flowRoot = root.querySelector('[data-compatibility-flow-root]');
    if (!flowRoot || flowRoot.dataset.initialized === 'true') return;

    flowRoot.dataset.initialized = 'true';

    const stage = flowRoot.querySelector('[data-flow-stage]');
    const backButton = flowRoot.querySelector('[data-flow-back]');
    const progressBar = flowRoot.querySelector('[data-flow-progress]');
    const progressRow = flowRoot.querySelector('.compatibility-flow-progress-row');
    const navShell = flowRoot.querySelector('[data-flow-nav]');
    const translationsNode = flowRoot.querySelector('[data-compatibility-flow-translations]');
    const destinationUrl = flowRoot.getAttribute('data-esim-destination-url') || '/pages/esim';
    const history = [];
    const copyIconMarkup = getCopyIconMarkup(root);
    let currentScreen = null;
    let currentPayload = null;
    let localeStrings = {};

    if (translationsNode) {
      try {
        localeStrings = JSON.parse(translationsNode.textContent);
      } catch (error) {
        console.error('Unable to parse compatibility flow translations', error);
      }
    }

    const progressByScreen = {
      start: 18,
      ios_settings: 32,
      ios_cellular: 52,
      ios_add_esim: 74,
      android_type: 24,
      samsung_settings: 34,
      samsung_connections: 48,
      samsung_sim_manager: 62,
      samsung_add_esim: 76,
      pixel_settings: 34,
      pixel_network: 48,
      pixel_sims: 58,
      pixel_add_sim: 68,
      pixel_setup_esim: 78,
      other_android_settings: 38,
      other_android_search: 58,
      other_android_add_esim: 78,
      quick_check_start: 18,
      eid_check: 40,
      secondary_platform: 62,
      likely_unsupported: 100,
      success: 100
    };

    function setProgress(screenId) {
      const progress = progressByScreen[screenId] || 18;
      flowRoot.style.setProperty('--compatibility-progress', progress + '%');
      if (progressBar) {
        progressBar.style.width = progress + '%';
      }
    }

    function getString(path, fallback) {
      const value = path.split('.').reduce(function(accumulator, part) {
        return accumulator && typeof accumulator === 'object' ? accumulator[part] : null;
      }, localeStrings);

      return typeof value === 'string' && value !== '' ? value : fallback;
    }

    function setNavigationVisibility(screenId) {
      if (!navShell || !progressRow) return;
      const shouldHide = screenId === 'start' || screenId === 'quick_check_start';
      navShell.hidden = false;
      progressRow.hidden = false;
      navShell.classList.toggle('is-placeholder', shouldHide);
    }

    function setBackVisibility() {
      if (!backButton) return;
      backButton.hidden = history.length === 0;
    }

    function button(label, action, variant, attributes) {
      const attrString = attributes || '';
      return '<button type="button" class="compatibility-flow-button' +
        (variant ? ' compatibility-flow-button--' + variant : '') +
        '" data-flow-action="' + action + '"' + attrString + '>' + label + '</button>';
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function renderSingleStep(config, direction) {
      const subtitle = config.copy ? '<p class="compatibility-flow-copy">' + config.copy + '</p>' : '';
      const lead = config.lead || '';
      const body = config.body ? '<div class="compatibility-flow-step-body">' + config.body + '</div>' : '';
      const question = config.question ? '<p class="compatibility-flow-copy">' + config.question + '</p>' : '';
      const actions = '<div class="compatibility-flow-actions">' + (config.actions || '') + '</div>';

      return (
        '<div class="compatibility-flow-step is-transitioning" data-direction="' + (direction || 'forward') + '" data-active-step>' +
          lead +
          '<h3 class="compatibility-flow-title">' + config.title + '</h3>' +
          subtitle +
          body +
          question +
          actions +
        '</div>'
      );
    }

    function openQuickCheckDialer() {
      const dialUri = 'tel:%2A%2306%23';

      try {
        const link = document.createElement('a');
        link.href = dialUri;
        link.setAttribute('aria-hidden', 'true');
        link.style.position = 'absolute';
        link.style.left = '-9999px';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        window.location.href = dialUri;
      }
    }

    function applyCopyFeedback(button) {
      if (!button) return;

      button.classList.remove('is-pressed');
      button.classList.add('is-copied');

      if (button.__copyFeedbackTimeout) {
        clearTimeout(button.__copyFeedbackTimeout);
      }

      button.__copyFeedbackTimeout = window.setTimeout(function() {
        button.classList.remove('is-copied');
      }, 2000);
    }

    function applyCopyPressFeedback(button) {
      if (!button || button.classList.contains('is-copied')) return;

      button.classList.remove('is-pressed');

      if (button.__copyPressFrame) {
        window.cancelAnimationFrame(button.__copyPressFrame);
      }

      if (button.__copyPressTimeout) {
        clearTimeout(button.__copyPressTimeout);
      }

      button.__copyPressFrame = window.requestAnimationFrame(function() {
        button.classList.add('is-pressed');

        button.__copyPressTimeout = window.setTimeout(function() {
          button.classList.remove('is-pressed');
        }, 160);
      });
    }

    function setBackButtonPressedState(button, isPressed) {
      if (!button) return;
      button.classList.toggle('is-pressed', !!isPressed);
    }

    function copyQuickCheckCode(button) {
      const code = '*#06#';

      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(code).then(function() {
          applyCopyFeedback(button);
        }).catch(function() {});
        return;
      }

      const input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', 'readonly');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();

      try {
        document.execCommand('copy');
        applyCopyFeedback(button);
      } catch (error) {}

      document.body.removeChild(input);
    }

    function getSecondaryCheckTarget() {
      const platformType = getPlatformType();

      if (platformType === 'iphone') {
        return {
          screenId: 'ios_settings',
          payload: { mode: 'ios', brand: 'apple' }
        };
      }

      if (platformType === 'android') {
        return {
          screenId: 'android_type',
          payload: { mode: 'android' }
        };
      }

      return {
        screenId: 'secondary_platform',
        payload: null
      };
    }

    function renderStep(config, direction) {
      if (!stage) return;
      currentScreen = config.id;
      currentPayload = config.payload || null;
      setProgress(config.id);
      setNavigationVisibility(config.id);
      setBackVisibility();
      stage.innerHTML = renderSingleStep(config, direction);
      bindStepEvents();
    }

    function goTo(screenId, options, payload) {
      const direction = options && options.direction ? options.direction : 'forward';
      const pushHistory = !(options && options.pushHistory === false);
      const nextPayload = typeof payload === 'undefined' ? currentPayload : payload;

      if (pushHistory && currentScreen) {
        history.push({ screenId: currentScreen, payload: currentPayload });
      }

      renderStep(buildScreen(screenId, nextPayload), direction);
    }

    function goBack() {
      if (history.length) {
        const previous = history.pop();
        renderStep(buildScreen(previous.screenId, previous.payload), 'back');
        return;
      }

      closeCompatibilityFlow();
    }

    function closeCompatibilityFlow() {
      history.length = 0;
      currentScreen = 'quick_check_start';
      currentPayload = null;

      if (modal && typeof modal.close === 'function') {
        modal.close();
      }
    }

    function getPlatformType() {
      const ua = navigator.userAgent || '';
      const platform = navigator.platform || '';
      const maxTouchPoints = navigator.maxTouchPoints || 0;
      if (/android/i.test(ua)) return 'android';
      if (/iPhone|iPod/i.test(ua)) return 'iphone';
      if (/iPad/i.test(ua) || (platform === 'MacIntel' && maxTouchPoints > 1)) return 'iphone';
      return null;
    }

    function buildScreen(screenId, payload) {
      switch (screenId) {
        case 'start':
        case 'quick_check_start':
          return {
            id: 'quick_check_start',
            title: getString('screens.quick_check.title', 'Let’s check your phone'),
            copy: getString('screens.quick_check.body', 'A quick check to see if your phone supports eSIM. Tap the *#06# button to fill the code automatically, then press Call. Or open the Phone app, enter the code yourself and press Call.'),
            body:
              '<div class="compatibility-flow-quick-check">' +
                '<div class="compatibility-flow-code-row">' +
                  '<div class="compatibility-flow-code-slot" aria-hidden="true"></div>' +
                  ((getPlatformType() === 'iphone' || getPlatformType() === 'android')
                    ? '<button type="button" class="compatibility-flow-code compatibility-flow-code-link" data-flow-action="open_dialer" aria-label="' + escapeHtml(getString('aria.open_dialer', 'Open Phone app with star hash zero six hash')) + '">*#06#</button>'
                    : '<div class="compatibility-flow-code" aria-label="' + escapeHtml(getString('aria.dial_code', 'Dial star hash zero six hash')) + '">*#06#</div>') +
                  '<button type="button" class="compatibility-flow-copy-button" data-flow-action="copy_quick_check" aria-label="' + escapeHtml(getString('buttons.copy_code', 'Copy code')) + '">' +
                    copyIconMarkup +
                  '</button>' +
                '</div>' +
              '</div>',
            actions: button(getString('buttons.done', 'Done'), 'eid_check', 'primary')
          };
        case 'eid_check':
          return {
            id: 'eid_check',
            title: getString('screens.eid_check.title', 'Look for “EID”'),
            copy: getString('screens.eid_check.body', 'EID is the eSIM ID on your phone. It usually appears as “EID” followed by a long number.'),
            question: getString('prompts.can_you_find_it', 'Can you find it?'),
            actions:
              button(getString('buttons.yes_i_see_it', 'Yes'), 'success', 'primary') +
              button(getString('buttons.no_i_do_not_see_it', 'No'), 'secondary_check')
          };
        case 'likely_unsupported':
          return {
            id: 'likely_unsupported',
            payload: payload || null,
            title: getString('screens.unsupported.title', 'eSIM may not be supported'),
            body:
              '<p class="compatibility-flow-copy">' + escapeHtml(getString('screens.unsupported.body', 'We couldn’t find an EID or an option to add an eSIM. That usually means this phone doesn’t support eSIM.')) + '</p>',
            actions: button(getString('buttons.close', 'Close'), 'close_flow', 'primary')
          };
        case 'secondary_platform':
          return {
            id: 'secondary_platform',
            title: getString('screens.secondary_platform.title', 'What kind of phone do you have?'),
            actions:
              button(getString('buttons.iphone', 'iPhone'), 'ios_settings', 'primary', ' data-flow-payload="ios"') +
              button(getString('buttons.android', 'Android'), 'android_type')
          };
        case 'ios_settings':
          return {
            id: 'ios_settings',
            payload: { mode: 'ios', brand: 'apple' },
            title: getString('screens.ios_settings.title', 'Open Settings'),
            copy: getString('screens.ios_settings.body', 'We’ll take it step by step.'),
            actions: button(getString('buttons.done', 'Done'), 'ios_cellular', 'primary')
          };
        case 'ios_cellular':
          return {
            id: 'ios_cellular',
            payload: { mode: 'ios', brand: 'apple' },
            title: getString('screens.ios_cellular.title', 'Tap Cellular'),
            copy: getString('screens.ios_cellular.body', 'This is where iPhone keeps your SIM and mobile network settings.'),
            actions: button(getString('buttons.done', 'Done'), 'ios_add_esim', 'primary')
          };
        case 'ios_add_esim':
          return {
            id: 'ios_add_esim',
            payload: { mode: 'ios', brand: 'apple' },
            title: getString('screens.ios_add_esim.title', 'Look for “Add eSIM”'),
            copy: getString('screens.ios_add_esim.body', 'You may also see “Set Up Cellular” instead.'),
            question: getString('prompts.can_you_find_it', 'Can you find it?'),
            actions:
              button(getString('buttons.yes_i_see_it', 'Yes'), 'success', 'primary') +
              button(getString('buttons.no_i_do_not_see_it', 'No'), 'likely_unsupported')
          };
        case 'android_type':
          return {
            id: 'android_type',
            title: getString('screens.android_type.title', 'Which Android phone do you use?'),
            actions:
              button(getString('buttons.samsung', 'Samsung'), 'samsung_settings', 'primary') +
              button(getString('buttons.google_pixel', 'Google Pixel'), 'pixel_settings') +
              button(getString('buttons.other', 'Other Android'), 'other_android_settings')
          };
        case 'samsung_settings':
          return {
            id: 'samsung_settings',
            payload: { mode: 'android', brand: 'samsung' },
            title: getString('screens.samsung_settings.title', 'Open Settings'),
            copy: getString('screens.samsung_settings.body', 'We’ll take it step by step.'),
            actions: button(getString('buttons.done', 'Done'), 'samsung_connections', 'primary')
          };
        case 'samsung_connections':
          return {
            id: 'samsung_connections',
            payload: { mode: 'android', brand: 'samsung' },
            title: getString('screens.samsung_connections.title', 'Tap Connections'),
            copy: getString('screens.samsung_connections.body', 'Look for Connections in Settings.'),
            actions: button(getString('buttons.done', 'Done'), 'samsung_sim_manager', 'primary')
          };
        case 'samsung_sim_manager':
          return {
            id: 'samsung_sim_manager',
            payload: { mode: 'android', brand: 'samsung' },
            title: getString('screens.samsung_sim_manager.title', 'Tap SIM manager'),
            copy: getString('screens.samsung_sim_manager.body', 'You’ll find it inside Connections.'),
            actions: button(getString('buttons.done', 'Done'), 'samsung_add_esim', 'primary')
          };
        case 'samsung_add_esim':
          return {
            id: 'samsung_add_esim',
            payload: { mode: 'android', brand: 'samsung' },
            title: getString('screens.samsung_add_esim.title', 'Look for “Add eSIM”'),
            copy: getString('screens.samsung_add_esim.body', 'This option lets your phone add an eSIM.'),
            question: getString('prompts.can_you_find_it', 'Can you find it?'),
            actions:
              button(getString('buttons.yes_i_see_it', 'Yes'), 'success', 'primary') +
              button(getString('buttons.no_i_do_not_see_it', 'No'), 'likely_unsupported')
          };
        case 'pixel_settings':
          return {
            id: 'pixel_settings',
            payload: { mode: 'android', brand: 'google' },
            title: getString('screens.pixel_settings.title', 'Open Settings'),
            copy: getString('screens.pixel_settings.body', 'We’ll take it step by step.'),
            actions: button(getString('buttons.done', 'Done'), 'pixel_network', 'primary')
          };
        case 'pixel_network':
          return {
            id: 'pixel_network',
            payload: { mode: 'android', brand: 'google' },
            title: getString('screens.pixel_network.title', 'Tap Network & internet'),
            copy: getString('screens.pixel_network.body', 'Look for Network & internet in Settings.'),
            actions: button(getString('buttons.done', 'Done'), 'pixel_sims', 'primary')
          };
        case 'pixel_sims':
          return {
            id: 'pixel_sims',
            payload: { mode: 'android', brand: 'google' },
            title: getString('screens.pixel_sims.title', 'Tap SIMs'),
            copy: getString('screens.pixel_sims.body', 'You’ll find it inside Network & internet.'),
            actions: button(getString('buttons.done', 'Done'), 'pixel_add_sim', 'primary')
          };
        case 'pixel_add_sim':
          return {
            id: 'pixel_add_sim',
            payload: { mode: 'android', brand: 'google' },
            title: getString('screens.pixel_add_sim.title', 'Tap Add SIM'),
            copy: getString('screens.pixel_add_sim.body', 'This opens the options for adding another SIM.'),
            actions: button(getString('buttons.done', 'Done'), 'pixel_setup_esim', 'primary')
          };
        case 'pixel_setup_esim':
          return {
            id: 'pixel_setup_esim',
            payload: { mode: 'android', brand: 'google' },
            title: getString('screens.pixel_setup_esim.title', 'Look for “Set up an eSIM”'),
            copy: getString('screens.pixel_setup_esim.body', 'This is the eSIM option we’re looking for.'),
            question: getString('prompts.can_you_find_it', 'Can you find it?'),
            actions:
              button(getString('buttons.yes_i_see_it', 'Yes'), 'success', 'primary') +
              button(getString('buttons.no_i_do_not_see_it', 'No'), 'likely_unsupported')
          };
        case 'other_android_settings':
          return {
            id: 'other_android_settings',
            payload: { mode: 'android', brand: 'other' },
            title: getString('screens.other_android_settings.title', 'Open Settings'),
            copy: getString('screens.other_android_settings.body', 'We’ll take it step by step.'),
            actions: button(getString('buttons.done', 'Done'), 'other_android_search', 'primary')
          };
        case 'other_android_search':
          return {
            id: 'other_android_search',
            payload: { mode: 'android', brand: 'other' },
            title: getString('screens.other_android_search.title', 'Search for “eSIM”'),
            copy: getString('screens.other_android_search.body', 'Use the search in Settings and type “eSIM”.'),
            actions: button(getString('buttons.done', 'Done'), 'other_android_add_esim', 'primary')
          };
        case 'other_android_add_esim':
          return {
            id: 'other_android_add_esim',
            payload: { mode: 'android', brand: 'other' },
            title: getString('screens.other_android_add_esim.title', 'Look for an eSIM option'),
            copy: getString('screens.other_android_add_esim.body', 'You may see “Add eSIM”, “Set up eSIM”, “Add SIM” or “Add mobile plan”.'),
            question: getString('prompts.can_you_find_it', 'Can you find it?'),
            actions:
              button(getString('buttons.yes_i_see_it', 'Yes'), 'success', 'primary') +
              button(getString('buttons.no_i_do_not_see_it', 'No'), 'likely_unsupported')
          };
        case 'success':
        default:
          return {
            id: 'success',
            lead:
              '<div class="compatibility-flow-success-icon" aria-hidden="true">' +
                '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                  '<path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
              '</div>',
            title: getString('screens.supported.title', 'Your phone supports eSIM'),
            copy: getString('screens.supported.body', 'You’re good to go.'),
            actions: button(getString('buttons.buy_an_esim', 'Buy an eSIM'), 'find_esim', 'primary')
          };
      }
    }

    function handleFindEsim() {
      const heroSearch = document.querySelector('.hero-search');
      if (modal && typeof modal.close === 'function') {
        modal.close();
      }

      if (heroSearch) {
        heroSearch.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(function() {
          const searchInput = heroSearch.querySelector('#search-input');
          if (searchInput) {
            searchInput.focus();
          }
        }, 350);
        return;
      }

      window.location.assign(destinationUrl);
    }

    function handleStartQuickCheck() {
      openQuickCheckDialer();
      goTo('eid_check');
    }

    function bindStepEvents() {
      stage.querySelectorAll('[data-flow-action]').forEach(function(actionButton) {
        actionButton.addEventListener('click', function(event) {
          const action = this.getAttribute('data-flow-action');

          if (action === 'find_esim') {
            event.preventDefault();
            handleFindEsim();
            return;
          }

          if (action === 'copy_quick_check') {
            event.preventDefault();
            applyCopyPressFeedback(this);
            copyQuickCheckCode(this);
            return;
          }

          if (action === 'open_dialer' || action === 'start_quick_check') {
            event.preventDefault();
            handleStartQuickCheck();
            return;
          }

          if (action === 'secondary_check') {
            event.preventDefault();
            const secondaryTarget = getSecondaryCheckTarget();
            goTo(secondaryTarget.screenId, null, secondaryTarget.payload);
            return;
          }

          if (action === 'close_flow') {
            event.preventDefault();
            event.stopPropagation();
            closeCompatibilityFlow();
            return;
          }

          const payloadOverride = this.getAttribute('data-flow-payload');
          if (payloadOverride === 'ios') {
            event.preventDefault();
            goTo(action, null, { mode: 'ios', brand: 'apple' });
            return;
          }

          event.preventDefault();
          goTo(action);
        });
      });
    }

    if (backButton) {
      backButton.setAttribute('aria-label', getString('aria.back', 'Back'));
      backButton.addEventListener('pointerdown', function() {
        setBackButtonPressedState(backButton, true);
      });
      backButton.addEventListener('pointerup', function() {
        setBackButtonPressedState(backButton, false);
      });
      backButton.addEventListener('pointercancel', function() {
        setBackButtonPressedState(backButton, false);
      });
      backButton.addEventListener('pointerleave', function() {
        setBackButtonPressedState(backButton, false);
      });

      backButton.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        setBackButtonPressedState(backButton, false);
        backButton.blur();
        goBack();
      }, true);
    }

    renderStep(buildScreen('quick_check_start'), 'forward');
    setBackVisibility();
  }

  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('.compatibility-button, .open-modal, [data-open-esim-modal]');
    if (!trigger) return;

    if (trigger.matches('.open-modal') && !trigger.closest('[data-compatibility-section]') && !trigger.hasAttribute('data-open-esim-modal')) {
      const href = trigger.getAttribute('href') || '';
      const isCompatibilityTrigger = trigger.hasAttribute('data-open-compatibility-modal') || href.indexOf('compatibility') !== -1;
      if (!isCompatibilityTrigger) return;
    }

    event.preventDefault();
    const content = getCompatibilityModalContent(trigger);
    if (content) {
      openCompatibilityModal(content);
    }
  });

  window.openCompatibilityModal = openCompatibilityModal;
  window.getCompatibilityModalContent = getCompatibilityModalContent;
  window.initializeCompatibilityFlow = initializeCompatibilityFlow;
})();
